var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "link-list-container",
      class: {
        "is-open": !_vm.collapsed,
        "mobile-clickable":
          _vm.widgetSettings.linkListCollapsible &&
          _vm.widgetSettings.linkHeadline,
      },
    },
    [
      _vm.widgetSettings.linkHeadline
        ? _c(
            "div",
            {
              staticClass: "link-list-title",
              on: {
                click: function ($event) {
                  return _vm.collapse()
                },
              },
            },
            [
              _c("h3", { style: `color: ${_vm.linkHeadlineColor} ` }, [
                _vm._v(_vm._s(_vm.widgetSettings.linkHeadline)),
              ]),
              _vm._v(" "),
              _vm.widgetSettings.linkListCollapsible
                ? _c("div", { staticClass: "link-list-title-icon" }, [
                    _c(
                      "div",
                      {
                        staticClass: "icon-container",
                        style: `color: ${_vm.widgetSettings.linkColor}`,
                      },
                      [
                        _c("list-svg-icons", {
                          staticClass: "icon",
                          attrs: { name: "ChevronDown" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "link-list-navigation-container",
          class: {
            "mobile-collapsed":
              _vm.collapsed && _vm.widgetSettings.linkHeadline,
          },
        },
        [
          _c(
            "b-nav",
            { staticClass: "link-list", attrs: { vertical: "" } },
            _vm._l(_vm.linkItems, function (item, index) {
              return _c(
                "li",
                { key: index, staticClass: "link-list-item" },
                [
                  _c(
                    "generic-link",
                    {
                      staticClass: "link-list-item-link",
                      style: `color: ${_vm.linkColor}`,
                      attrs: {
                        href: item.linkUrl,
                        title: item.linkTitle,
                        target: item.linkTarget,
                      },
                    },
                    [
                      _vm.widgetSettings.linkIcon &&
                      _vm.widgetSettings.linkIconPosition === "left"
                        ? _c(
                            "span",
                            {
                              staticClass: "link-list-item-icon icon-left",
                              style: `color: ${_vm.linkIconColor}`,
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "icon-container",
                                  style: `border-color: ${_vm.linkIconColor}`,
                                },
                                [
                                  _c("list-svg-icons", {
                                    staticClass: "icon",
                                    attrs: {
                                      name: _vm.widgetSettings.linkIcon,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "link-list-item-text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.linkText) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.widgetSettings.linkIcon &&
                      _vm.widgetSettings.linkIconPosition === "right"
                        ? _c(
                            "span",
                            {
                              staticClass: "link-list-item-icon icon-right",
                              style: `color: ${_vm.linkIconColor}`,
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "icon-container" },
                                [
                                  _c("list-svg-icons", {
                                    staticClass: "icon float-right",
                                    attrs: {
                                      name: _vm.widgetSettings.linkIcon,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }